import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-right: 80px;
    text-align: start;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding-right: 0;
    }
  `};
`;

export const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
  `};
`;

export const Subtitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 16px 0;
  `};
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryMedium};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
  `};
`;

export const Text = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 24px;
    margin: 0;
  `};
`;

export const InfosList = styled.ul`
  padding-inline-start: 0;
  list-style-type: none;
`;

export const Note = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 24px;
    margin: 0;
  `};
`;

export const ListItem = styled.li`
  align-items: start;
  display: flex;
  gap: 12px;
  margin: 12px 0;
`;
